import { useMainSelector } from '../../useMainSelector';

export const useUserDataMapping = () => {
  const {
    settings: { userDataMapping },
  } = useMainSelector();

  return {
    userDataMapping,
  };
};
